/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	ExportTargetMappingCreateRequest,
	ExportTargetMappingCreateResponse,
} from '../types/ExportTargetMappingCreate'

/**
 * POST /export-target-mappings
 * @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportTargetMappingController.php ExportTargetMappingController::create
 */
export async function exportTargetMappingCreate(
	data: ExportTargetMappingCreateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ExportTargetMappingCreateResponse>> {
	return axiosInstance.post('/export-target-mappings', data, config)
}
